import RestResource from '../rest.service';

export default class ArticlesService extends RestResource {
  map(payload) {
    return {
      description: payload.description,
      code: payload.code,
      stock: payload.stock,
      availability: payload.availability,
      variety_id: payload.variety,
      campaign_id: payload.campaign,
    };
  }

  constructor() {
    super('articles');
  }
}
